import styled from 'styled-components';

export const TooltipWrapper = styled.div`
  position: fixed;
  top: 70%;
  bottom: 50%;
  left: 25%;
  background-color: black;
  opacity: 0.9;
  width: 25%;
  z-index: 9999;
  
  -webkit-animation: 3s ease 0s normal forwards 1 fadein;
  animation: 3s ease 0s normal forwards 1 fadein;
  
  ${props => props.theme.mediaQueries.tablet}{
    width: 40%;
    top: 40%;
    padding: 10px;
    position: fixed;
    left: 11%;
  }

  ${props => props.theme.mediaQueries.phone}{
    width: 80%;
    top: 40%;
    position: fixed;
    left: 0;
    right: 0;
  }

  margin: auto;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NewFeaturesWrapper = styled.div`
  position: absolute;
  background-color: black;
  opacity: 0.9;
  width: 300px;
  top: 43px;
  right: 0;
  z-index: 9999;
  margin: auto;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 10px;
  &::before {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 9px solid black;
    content: "";
    right: 20px;
    top: -9px;
    position: absolute;
  }
  ${props => props.theme.mediaQueries.phone}{
    width: 270px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
`;
